/*
 * Party Deko World: Zeichenwahl (Zahlen und Buchstaben).
 *
 * Eine Logik fuer zwei Orte und zwei Sorten:
 *   - gross   auf der Produktseite (product.ballonwahl.json)
 *   - kompakt im Aufklappfeld der Produktkarte
 *   - Sorte 'zahl'      → Feld nimmt Ziffern, Handle folienballon-zahl-N
 *   - Sorte 'buchstabe' → Feld nimmt ein Wort, Handle folienballon-buchstabe-X
 *
 * Was sie kann:
 *   1. Zahl oder Wort eintippen. Wiederholungen werden als Menge gezaehlt
 *      (11 = zweimal die Eins, ANNA = zweimal A und zweimal N).
 *   2. Nur Groessen und Farben zeigen, die es fuer JEDES Zeichen gibt und die
 *      da sind. Die Varianten der anderen Zeichen kommen ueber
 *      /products/<handle>.js.
 *   3. Was fehlt, blass zeigen statt verschwinden lassen. Die Namen stehen am
 *      Punkt (title), nicht als Aufzaehlung — sonst wird es eine Textwueste.
 *   4. Helium je Ballon dazulegen. Nur ab 66 cm, nur Abholung. 86 cm bekommt
 *      die 102-cm-Fuellung, weil es fuer 86 cm keinen eigenen Fuellpreis gibt
 *      (Entscheidung Stephan, 20.09.2026).
 *
 * Die festen Texte stehen im Snippet pdw-zahlenwahl.liquid, nicht hier.
 * Hier wird nur gesetzt, was sich rechnet: Anzahlen, Preise und die
 * Ueberschrift im Singular oder Plural.
 *
 * Unterschied: gross wechselt die Seite, wenn das erste Zeichen nicht das
 * angezeigte ist, damit Bild und Zeichen zusammenpassen. Kompakt wechselt nie —
 * dort steht der Kunde schon vor der Karte und will nur ablegen.
 *
 * Liegt als Datei im Theme, damit der Browser sie einmal laedt, auch wenn
 * zehn Karten auf der Seite stehen.
 */
(function () {
  if (window.__pdwZahlenwahl) return;
  window.__pdwZahlenwahl = 1;

  var T = (window.pdwT && window.pdwT.zahlenwahl) || {};

  var HELIUM = { '66 cm': '66', '86 cm': '86', '102 cm': '102', '163 cm': '163' };
  var gecacht = {};

  function sorte(z) { return z.dataset.pdwSorte === 'buchstabe' ? 'buchstabe' : 'zahl'; }

  function erlaubt(z) { return sorte(z) === 'buchstabe' ? /[^A-Z&]/g : /[^0-9]/g; }

  function saeubern(z, wert) {
    var w = wert || '';
    if (sorte(z) === 'buchstabe') w = w.toUpperCase();
    return w.replace(erlaubt(z), '');
  }

  function handleVon(z, zeichen) {
    if (sorte(z) === 'buchstabe') {
      return '/products/folienballon-buchstabe-' + (zeichen === '&' ? 'und' : zeichen.toLowerCase());
    }
    return '/products/folienballon-zahl-' + zeichen;
  }

  function daten(z) {
    if (z.__d) return z.__d;
    try { z.__d = JSON.parse(z.querySelector('.pdw-zw__daten').textContent); } catch (e) { z.__d = null; }
    return z.__d;
  }

  function gewaehlt(z, name) {
    var a = z.querySelector('[data-pdw-opt="' + name + '"][aria-pressed="true"]');
    return a ? a.dataset.pdwWert : null;
  }

  function ziffern(z) {
    return saeubern(z, z.querySelector('.pdw-zw__zahl').value).split('').filter(Boolean);
  }

  function ziffernSatz(z, liste) {
    var e = liste.filter(function (x, i) { return liste.indexOf(x) === i; });
    var m = e.map(function (x) { return (sorte(z) === 'buchstabe' ? T.satz_das : T.satz_die).replace('{x}', x); });
    if (m.length === 1) return m[0];
    return verbinden(m.slice(0, -1).join(', '), m[m.length - 1]);
  }

  function verbinden(a, b) { return T.und.replace('{a}', a).replace('{b}', b); }

  function eigene(z) { return z.dataset.pdwZahl; }

  function paare(vs) {
    var s = {};
    vs.forEach(function (v) { s[v.options.join('|')] = v.price; });
    return s;
  }

  function eigenePaare(z) {
    var d = daten(z);
    var s = {};
    d.varianten.forEach(function (v) { if (v.da) s[v.o.join('|')] = v.c; });
    return s;
  }

  function variantenHolen(z, zeichen) {
    var schluessel = sorte(z) + ':' + zeichen;
    if (gecacht[schluessel]) return Promise.resolve(gecacht[schluessel]);
    return fetch(handleVon(z, zeichen) + '.js')
      .then(function (r) { if (!r.ok) throw new Error(T.nicht_gefunden.replace('{zeichen}', zeichen)); return r.json(); })
      .then(function (p) {
        gecacht[schluessel] = p.variants.filter(function (v) { return v.available; });
        return gecacht[schluessel];
      });
  }

  function schnittmenge(z) {
    var liste = ziffern(z);
    var eigen = eigenePaare(z);
    var andere = liste.filter(function (x, i) { return x !== eigene(z) && liste.indexOf(x) === i; });
    if (!liste.length) return Promise.resolve({ paare: eigen, fehlend: [] });

    return Promise.all(andere.map(function (x) {
      return variantenHolen(z, x).then(function (vs) { return { zahl: x, p: paare(vs) }; })
        .catch(function () { return { zahl: x, p: null }; });
    })).then(function (ergebnisse) {
      var erg = {};
      Object.keys(eigen).forEach(function (s) { erg[s] = eigen[s]; });
      var fehlend = [];
      ergebnisse.forEach(function (e) {
        if (!e.p) { fehlend.push(e.zahl); return; }
        Object.keys(erg).forEach(function (s) { if (!(s in e.p)) delete erg[s]; });
      });
      return { paare: erg, fehlend: fehlend };
    });
  }

  function melden(z, t) {
    var m = z.querySelector('.pdw-zw__meldung');
    if (m) m.textContent = t || '';
  }

  function bauen(z, erg) {
    var d = daten(z);
    var ig = d.namen.indexOf('Größe');
    var iff = d.namen.indexOf('Farbe');
    var schluessel = Object.keys(erg.paare);

    var gMoeglich = {};
    schluessel.forEach(function (s) { gMoeglich[s.split('|')[ig]] = 1; });

    var vorherG = gewaehlt(z, 'Größe') || z.__wunschG;
    var zielG = z.querySelector('.pdw-zw__groessen');
    zielG.innerHTML = '';
    d.groessen.forEach(function (g) {
      if (!gMoeglich[g]) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdw-zw__groesse';
      b.textContent = g;
      b.setAttribute('aria-pressed', g === vorherG ? 'true' : 'false');
      b.dataset.pdwOpt = 'Größe';
      b.dataset.pdwWert = g;
      zielG.appendChild(b);
    });
    if (!gewaehlt(z, 'Größe') && zielG.firstChild) zielG.firstChild.setAttribute('aria-pressed', 'true');

    var g = gewaehlt(z, 'Größe');
    var fMoeglich = {};
    schluessel.forEach(function (s) {
      var t = s.split('|');
      if (t[ig] === g) fMoeglich[t[iff]] = 1;
    });

    var vorherF = gewaehlt(z, 'Farbe') || z.__wunschF;
    var zielF = z.querySelector('.pdw-zw__farben');
    var zielFehl = z.querySelector('.pdw-zw__fehlfarben');
    zielF.innerHTML = '';
    zielFehl.innerHTML = '';
    var gezeigt = 0;
    var fehlt = 0;

    d.farben.forEach(function (f) {
      if (fMoeglich[f.name]) {
        gezeigt++;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdw-zw__farbe';
        b.style.background = f.farbe;
        b.title = f.name;
        b.setAttribute('aria-label', f.name);
        b.setAttribute('aria-pressed', f.name === vorherF ? 'true' : 'false');
        b.dataset.pdwOpt = 'Farbe';
        b.dataset.pdwWert = f.name;
        zielF.appendChild(b);
      } else {
        fehlt++;
        var s = document.createElement('span');
        s.className = 'pdw-zw__fehlfarbe';
        s.style.background = f.farbe;
        s.title = T.farbe_nicht_da.replace('{farbe}', f.name);
        s.setAttribute('aria-label', T.farbe_nicht_da.replace('{farbe}', f.name));
        zielFehl.appendChild(s);
      }
    });

    if (!gewaehlt(z, 'Farbe') && zielF.firstChild) zielF.firstChild.setAttribute('aria-pressed', 'true');
    z.querySelector('.pdw-zw__farbname').textContent = gewaehlt(z, 'Farbe') || '';

    var hinweis = z.querySelector('.pdw-zw__farbhinweis');
    var liste = ziffern(z);
    var satz = liste.length ? ziffernSatz(z, liste) : '';

    if (!gezeigt) {
      hinweis.textContent = T.hinweis_keine.replace('{groesse}', g || T.groesse_diese).replace('{satz}', satz);
      hinweis.hidden = false;
    } else if (liste.length > 1) {
      hinweis.textContent = (gezeigt === 1 ? T.hinweis_eine : T.hinweis_mehrere).replace('{satz}', satz);
      hinweis.hidden = false;
    } else {
      hinweis.hidden = true;
    }

    var mehr = z.querySelector('.pdw-zw__mehr');
    var kasten = z.querySelector('.pdw-zw__fehlend');
    var kopf = z.querySelector('.pdw-zw__fehlkopf');

    if (fehlt) {
      mehr.hidden = false;
      mehr.textContent = (fehlt === 1 ? T.mehr_eine : T.mehr_viele).replace('{anzahl}', fehlt);
      kopf.innerHTML = '<b>' + (fehlt === 1 ? T.fehlkopf_eine : T.fehlkopf_viele) + '</b>';
    } else {
      mehr.hidden = true;
      mehr.setAttribute('aria-expanded', 'false');
      kasten.hidden = true;
    }

    if (erg.fehlend.length) {
      melden(z, T.pruefen_nicht.replace('{liste}', erg.fehlend.reduce(function (a, b) { return verbinden(a, b); })));
    }
  }

  function heliumAuffrischen(z) {
    var kasten = z.querySelector('.pdw-zw__helium');
    if (!kasten) return;
    var g = gewaehlt(z, 'Größe');
    var s = HELIUM[g];
    var id = s ? z.getAttribute('data-h-' + s) : '';
    var ja = kasten.querySelector('input[value="ja"]');
    var text = kasten.querySelector('.pdw-zw__heliumtext');
    var hinweis = kasten.querySelector('.pdw-zw__abholung');

    if (s && id) {
      ja.disabled = false;
      text.innerHTML = T.helium_ja_html.replace('{preis}', z.getAttribute('data-p-' + s));
    } else {
      ja.disabled = true;
      if (ja.checked) kasten.querySelector('input[value="nein"]').checked = true;
      text.innerHTML = g ? T.helium_geht_nicht_html.replace('{groesse}', g) : T.helium_groesse_html;
    }
    hinweis.hidden = !(ja.checked && !ja.disabled);
  }

  function geld(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }

  function knopfAuffrischen(z, erg) {
    var b = z.querySelector('.pdw-zw__kaufen');
    var g = gewaehlt(z, 'Größe');
    var f = gewaehlt(z, 'Farbe');
    var liste = ziffern(z);

    if (!liste.length) {
      b.disabled = true;
      b.textContent = sorte(z) === 'buchstabe' ? T.tipp_wort : T.tipp_zahl;
      return;
    }
    if (!g || !f) { b.disabled = true; b.textContent = T.keine_farbe; return; }

    var d = daten(z);
    var ig = d.namen.indexOf('Größe');
    var iff = d.namen.indexOf('Farbe');
    var stueck = null;
    (erg && erg.paare ? Object.keys(erg.paare) : []).forEach(function (s) {
      var t = s.split('|');
      if (t[ig] === g && t[iff] === f) stueck = erg.paare[s];
    });

    var ja = z.querySelector('input[value="ja"]');
    var sl = HELIUM[g];
    var mit = ja && ja.checked && !ja.disabled && sl;
    var summe = null;
    if (stueck != null) {
      summe = stueck * liste.length;
      if (mit) summe += parseInt(z.getAttribute('data-c-' + sl), 10) * liste.length;
    }

    b.disabled = false;
    b.textContent = (liste.length === 1
      ? (summe != null ? T.knopf_ein_preis : T.knopf_ein)
      : (summe != null ? T.knopf_viele_preis : T.knopf_viele)
    ).replace('{anzahl}', liste.length).replace('{preis}', summe != null ? geld(summe) : '');
  }

  function auffrischen(z) {
    var lauf = (z.__lauf || 0) + 1;
    z.__lauf = lauf;
    schnittmenge(z).then(function (erg) {
      if (z.__lauf !== lauf) return;
      z.__erg = erg;
      bauen(z, erg);
      heliumAuffrischen(z);
      knopfAuffrischen(z, erg);
    });
  }

  function vielleichtWechseln(z) {
    if (z.dataset.pdwForm !== 'gross') return false;
    var liste = ziffern(z);
    if (!liste.length) return false;
    var erste = liste[0];
    if (erste === eigene(z)) return false;

    var s = new URLSearchParams();
    s.set('pdw-zahl', liste.join(''));
    var g = gewaehlt(z, 'Größe');
    var f = gewaehlt(z, 'Farbe');
    if (g) s.set('pdw-Groesse', g);
    if (f) s.set('pdw-Farbe', f);
    window.location.href = handleVon(z, erste) + '?' + s.toString();
    return true;
  }

  function kaufen(z) {
    var g = gewaehlt(z, 'Größe');
    var f = gewaehlt(z, 'Farbe');
    var liste = ziffern(z);
    if (!liste.length || !g || !f) return;

    var mengen = {};
    liste.forEach(function (x) { mengen[x] = (mengen[x] || 0) + 1; });

    var ja = z.querySelector('input[value="ja"]');
    var s = HELIUM[g];
    var mit = ja && ja.checked && !ja.disabled && s;
    var hv = mit ? parseInt(z.getAttribute('data-h-' + s), 10) : null;

    var b = z.querySelector('.pdw-zw__kaufen');
    b.disabled = true;
    melden(z, T.einen_moment);

    var fehler = [];
    Promise.all(Object.keys(mengen).map(function (zeichen) {
      var hol = zeichen === eigene(z)
        ? Promise.resolve(daten(z).varianten.filter(function (v) { return v.da; })
            .map(function (v) { return { id: v.id, options: v.o }; }))
        : variantenHolen(z, zeichen);
      return hol.then(function (vs) {
        var v = vs.filter(function (x) {
          return x.options.indexOf(g) > -1 && x.options.indexOf(f) > -1;
        })[0];
        if (!v) throw new Error(T.nicht_in.replace('{zeichen}', zeichen).replace('{farbe}', f).replace('{groesse}', g));
        return { id: v.id, quantity: mengen[zeichen],
          fuer: (sorte(z) === 'buchstabe' ? 'Buchstabe ' : 'Zahl ') + zeichen + ' · ' + f + ' · ' + g };
      }).catch(function (e) { fehler.push(e.message); return null; });
    })).then(function (posten) {
      var gute = posten.filter(Boolean);
      if (!gute.length) throw new Error(fehler.join(' '));
      var anzahl = 0;
      var alle = [];
      // Je Ballon eine eigene Heliumzeile mit gemeinsamem Schluessel _pdw_k,
      // damit der Warenkorb beide zu einer Zeile zusammenlegen kann.
      gute.forEach(function (x) {
        anzahl += x.quantity;
        var b = { id: x.id, quantity: x.quantity };
        if (mit) b.properties = { 'Füllung': 'Mit Helium gefüllt — nur Abholung im Laden' };
        alle.push(b);
        if (mit && hv) {
          b.properties._pdw_k = String(x.id);
          alle.push({ id: hv, quantity: x.quantity, properties: { 'Für': x.fuer, '_pdw_k': String(x.id), '_pdw_n': '1' } });
        }
      });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: alle })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || T.geklappt_nicht);
          return anzahl;
        });
      });
    }).then(function (anzahl) {
      var t = anzahl === 1 ? T.liegt_ein : T.liegen_viele.replace('{anzahl}', anzahl);
      if (mit) t += ' ' + T.helium_dabei;
      if (fehler.length) t += ' ' + fehler.join(' ');
      melden(z, t);
      try { document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'pdw' } })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pdw' } })); } catch (e) {}
    }).catch(function (err) {
      melden(z, err.message || T.geklappt_nicht);
    }).then(function () {
      knopfAuffrischen(z, z.__erg);
    });
  }

  function starten(z) {
    if (z.__start) return;
    z.__start = 1;

    var p = new URLSearchParams(window.location.search);
    if (z.dataset.pdwForm === 'gross') {
      var wunschZ = p.get('pdw-zahl');
      z.__wunschG = p.get('pdw-Groesse') || p.get('pdw-Größe');
      z.__wunschF = p.get('pdw-Farbe');
      if (wunschZ) z.querySelector('.pdw-zw__zahl').value = saeubern(z, wunschZ);
    }

    auffrischen(z);

    z.addEventListener('click', function (e) {
      var mehr = e.target.closest('.pdw-zw__mehr');
      if (mehr) {
        var kasten = z.querySelector('.pdw-zw__fehlend');
        var offen = mehr.getAttribute('aria-expanded') === 'true';
        mehr.setAttribute('aria-expanded', offen ? 'false' : 'true');
        kasten.hidden = offen;
        return;
      }

      var opt = e.target.closest('[data-pdw-opt]');
      if (opt) {
        z.querySelectorAll('[data-pdw-opt="' + opt.dataset.pdwOpt + '"]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === opt ? 'true' : 'false');
        });
        if (opt.dataset.pdwOpt === 'Größe') {
          z.__wunschF = gewaehlt(z, 'Farbe');
          var f = z.querySelector('[data-pdw-opt="Farbe"][aria-pressed="true"]');
          if (f) f.setAttribute('aria-pressed', 'false');
        }
        melden(z, '');
        auffrischen(z);
        return;
      }

      if (e.target.closest('.pdw-zw__kaufen')) kaufen(z);
    });

    z.addEventListener('change', function (e) {
      if (e.target.type === 'radio') { heliumAuffrischen(z); knopfAuffrischen(z, z.__erg); }
    });

    var tippen;
    var feld = z.querySelector('.pdw-zw__zahl');
    feld.addEventListener('input', function () {
      var sauber = saeubern(z, feld.value);
      if (feld.value !== sauber) feld.value = sauber;
      melden(z, '');
      clearTimeout(tippen);
      tippen = setTimeout(function () {
        if (vielleichtWechseln(z)) return;
        auffrischen(z);
      }, 600);
    });
  }

  document.addEventListener('click', function (e) {
    var auf = e.target.closest ? e.target.closest('.pdw-zw-auf') : null;
    if (!auf) return;
    var huelle = document.getElementById(auf.getAttribute('aria-controls'));
    if (!huelle) return;
    var offen = auf.getAttribute('aria-expanded') === 'true';

    document.querySelectorAll('.pdw-zw-auf[aria-expanded="true"]').forEach(function (x) {
      x.setAttribute('aria-expanded', 'false');
      var h = document.getElementById(x.getAttribute('aria-controls'));
      if (h) h.hidden = true;
    });

    if (!offen) {
      auf.setAttribute('aria-expanded', 'true');
      huelle.hidden = false;
      var z = huelle.querySelector('.pdw-zw');
      if (z) starten(z);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var auf = document.querySelector('.pdw-zw-auf[aria-expanded="true"]');
    if (!auf) return;
    auf.setAttribute('aria-expanded', 'false');
    var h = document.getElementById(auf.getAttribute('aria-controls'));
    if (h) h.hidden = true;
    auf.focus();
  });

  function los() {
    document.querySelectorAll('.pdw-zw[data-pdw-form="gross"]').forEach(starten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();